import React from 'react'
import SideMenu from '../../components/SideMenu'
import * as S from './styles'

const SideMenuTemplate = ({ children }) => {
  return (
    <S.Container>
      <SideMenu />
      <S.MainContent>
        {children}
      </S.MainContent>
    </S.Container>
  )
}

export default SideMenuTemplate
